import { BaseConfigType } from './default';
import ProductionConfig from './production';

const Config: BaseConfigType = {
  ...ProductionConfig,
  sentry_dsn: 'https://9f80411ee6ed4d0c8c4701f476721cab@o314572.ingest.sentry.io/6037519',
  sentry_org: 'zigzag-alpha',
  baseDomain: 'beta.zigzag.kr',
  apiBaseUrl: 'https://api.beta.zigzag.kr/api/store',
  redirectAppUrl: 'https://beta.zigzag.kr',
  apiConsumerBaseUrl: 'https://api.beta.zigzag.kr/api/2',
  assetPrefix: `https://store.beta.zigzag.kr/resources/${process.env.ARCH}/${process.env.IMAGE_TAG}_${process.env.WORKSPACE}`,
  simplePayPassword:
    'https://api.beta.zigzag.kr/api/security-keypad/static/js/simple_pay/simple_pay_password_beta.js?t=20231218',
  appUrl: 'https://store.beta.zigzag.kr',
  contentUrl: 'https://content.beta.zigzag.kr',
  resUrl: 'https://cf.res.s.zigzag.kr',
  feResUrl: 'https://cf.fe.s.zigzag.kr',
  business_juso_api_key: 'U01TX0FVVEgyMDIyMTEwNzEzMDEzMjExMzE5Mjc=',
  zigzag_postcode_url: 'https://store.beta.zigzag.kr/postcode',
  zendesk_url: 'https://kakaostyle.zendesk.com/hc/p/requests-with-sso',
  zendesk_url_posty: 'https://posty-kakaostyle.zendesk.com/hc/p/requests-with-sso',
  /** @description marketing start*/
  ga4_id: '',
  amplitude_id: '',
  apps_flyer_pba_id: '',
  airbridge_app: 'zigzagbeta',
  airbridge_web_token: 'a7bdc36fb65d4de18b313ddb49c2c3a6',
  naver_account_id: '',
  /** marketing end */
  toss_client_id: 'bf1ocr42i3ymvaicoervdyv9g5n8v1lg',
};

export default Config;
